import React from 'react';
import {
  waitingRoomJoinInfoStyle,
  waitingRoomLeaveButtonStyle,
  waitingRoomControlsStyle,
  primaryButtonStyle,
} from '../WaitingRoom/styles';

const joinButtonStyle = {
  ...primaryButtonStyle,
  width: '100%',
  height: 44,
  opacity: 1,
};

const waitingRoomJoinInfoCenteredStyle = {
  ...waitingRoomJoinInfoStyle,
  textAlign: 'center',
};

const waitingRoomControlsCenteredStyle = {
  ...waitingRoomControlsStyle,
  justifyContent: 'center',
};

const WaitingRoomJoinPanel = ({ t, participantCount, onJoin, onLeave }) => (
  <>
    <button
      type="button"
      style={joinButtonStyle}
      onClick={onJoin}
    >
      {t('VideoChatV2.waiting.joinNow')}
    </button>
    <div style={waitingRoomJoinInfoCenteredStyle}>
      {t('VideoChatV2.waiting.joiningWith')} <b>{t('VideoChatV2.participantsCount', { count: participantCount })}</b>
    </div>
    <div style={waitingRoomControlsCenteredStyle}>
      <button type="button" style={waitingRoomLeaveButtonStyle} onClick={onLeave}>
        {t('VideoChatV2.leave')}
      </button>
    </div>
  </>
);

export default React.memo(WaitingRoomJoinPanel);
